import Vue from 'vue'
import router from './router'
import store from './storages'
import dataMix from './mixins/dataMix'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import VueTinySlider from 'vue-tiny-slider'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import utilsMix from './mixins/utilsMix'
import authMix from './mixins/authMix'
import minioMix from './mixins/minioMix'
import VueObserveVisibility from 'vue-observe-visibility'
import $ from 'jquery'
import VueCookies from 'vue-cookies'
import Vuelidate from 'vuelidate'
import VueCodemirror from 'vue-codemirror'
import Notifications from 'vue-notification'
import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueFetch from 'vue-fetch'
import 'codemirror/lib/codemirror.css'
import {SimpleSVG} from 'vue-simple-svg'
import VTooltip from 'v-tooltip'

Vue.component('simple-svg', SimpleSVG)

Vue.use(VTooltip)
Vue.use(Vuelidate)
Vue.use(VueObserveVisibility)
Vue.use(VueApollo)
Vue.use(VueCookies)
Vue.use(VueCodemirror)
Vue.use(Notifications)
Vue.use(VueAxios, axios)
Vue.use(VueFetch, {polyfill: false})

Vue.component('v-select', vSelect)
Vue.component('v-datepicker', Datepicker)

Vue.config.productionTip = false

Vue.component('tiny-slider', VueTinySlider)
Vue.component('vue-custom-scrollbar', vueCustomScrollbar)
export const eventBus = new Vue()

Vue.mixin(dataMix)
Vue.mixin(utilsMix)
Vue.mixin(authMix)
Vue.mixin(minioMix)

// console.log(store)
store.dispatch('SET_VALUE', {key: 'host', value: process.env.VUE_APP_HOST})
store.dispatch('SET_VALUE', {key: 'ngwHost', value: process.env.VUE_APP_NGW_HOST})
store.dispatch('SET_VALUE', {key: 'analitHost', value: process.env.VUE_APP_ANALIT_HOST})
store.dispatch('SET_VALUE', {key: 'minioHost', value: process.env.VUE_APP_MINIO_HOST})
store.dispatch('SET_VALUE', {key: 'iamHost', value: process.env.VUE_APP_IAM_HOST})

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_HOST + '/ugeoapi/graphql/'
})

const authLink = setContext((_, { headers }) => {
  let token = VueCookies.get('access')
  // return the headers to the context so HTTP link can read them
  return {
    headers: {
      // ...headers,
      authorization: `JWT ${token}`
    }
  }
})

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  // link: httpLink,
  cache: new InMemoryCache(),
  connectToDevTools: true
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

global.jQuery = $
global.$ = $

if (VueCookies.get('refresh') !== null) {
  authMix.methods.getAccessToken().then(response => {
    VueCookies.set('access', response.data.token)
    authMix.methods.setUserInfoMix(response.data.token)
    store.dispatch('SET_VALUE', {key: 'isAuthorized', value: true})
    axios.defaults.headers.common['Authorization'] = 'JWT ' + response.data.token
    initApp()
  }).catch(error => {
    console.warn('Failed to update token', error)
    authMix.methods.clearCookies()
    router.push('/login')
    initApp()
  })
} else {
  authMix.methods.clearCookies()
  router.push('/login')
  initApp()
}

function initApp () {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    apolloProvider,
    store,
    components: { App },
    template: '<App/>'
  })
}



// WEBPACK FOOTER //
// ./src/main.js